<template>
<div class="bg-white">
    <div class="topbar hidden lg:flex flex-row items-center justify-between pl-4 py-4">
        <div class="page-header main-tenant-color">
            {{ cname }}
        </div>
        <div class="flex nav-color flex-row justify-between">
            <div id="tenant_web_manual">
                <a href="https://edc-lms-public-images.s3-eu-west-2.amazonaws.com/files/EDCLearn.com+LEARNER+Manual+v2.pdf">
                    Manual
                    <i class="text-lg cursor-pointer nav-color fas fa-book"></i>
                </a>
            </div>
            <!-- <div id="tenant_web_tour" class="mx-1 cursor-pointer" @click="takeTour">
                Take the tour
            </div> -->
            <div @click="$router.push({ name: 'tenant-notifications-home' })">
                <i class="text-lg  cursor-pointer nav-color fas fa-bell"></i>
            </div>
            <div class="mx-1 cursor-pointer">
                <i class="fas fa-user-circle" @click="$router.push({ name: 'tenant-profile' })"></i>
            </div>
            <div class="cursor-pointer mx-1" @click.prevent="handleLogout">
                Logout
            </div>
        </div>
    </div>
    <div class="lg:hidden flex flex-row justify-between px-4 py-4">
        <div>
            <span @click="$emit('toggle-nav', true)" class="cursor-pointer"><i class="fas fa-bars fa-2x"></i></span>
        </div>
        <div class="nav-color">
            <span id="tenant_mobile_manual mr-6">
                <a href="https://edc-lms-public-images.s3-eu-west-2.amazonaws.com/files/EDCLearn.com+LEARNER+Manual+v2.pdf">
                    <i class="text-lg cursor-pointer nav-color fas fa-book"></i>
                </a>
            </span>
            <!-- <span id="tenant_mobile_tour" class="mx-1 cursor-pointer mr-6" @click="takeTour2">
                <i class="text-lg cursor-pointer nav-color fas fa-question"></i>
            </span> -->
            <span class="cursor-pointer mr-6"><i class="fas fa-bell " @click="$router.push({name : 'tenant-notifications-home'})"></i></span>
            <span><i class="fas fa-user-circle mr-6 " @click="$router.push({ name: 'tenant-profile' })"></i></span>
            <span class="cursor-pointer mx-1" @click.prevent="handleLogout">
                <i class="fas fa-power-off"></i>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import colors from "@/utils/colors";
export default {
    data() {
        return {
            cname: "",
            form: {},
            user: this.$store.state.auth.user,
        };
    },
    methods: {
        ...mapActions(["logout", "fetchSingleTenant"]),
        async handleLogout() {
            this.logout();
            this.$router.push("/tenant/login");
        },
        // takeTour() {
        //     this.$Bus.$emit("start-tenant", {});
        //     this.$Bus.$emit("start-tenant-tour", {});
        // },
        // takeTour2() {
        //     this.$Bus.$emit("start-mobile-tenant-tour", {});
        //     this.$Bus.$emit("show-tenant-sidenav", {});
        // },
    },
    async mounted() {
        let user = await this.fetchSingleTenant({
            id: this.user.id,
        });

        this.cname = user.tenant_profile.company_name;
        // //console.log(user)
        // this.fetchAdminRoles();
    },
};
</script>

<style lang="scss" scoped>
.nav-color {
    color: color(lms-tenant);
}

.page-header {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 42px;
    color: color(lms-tenant) !important;
    letter-spacing: 0.11px;
}

.page-sub {
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.11px;

    color: color(lms-tenant);
}
</style>
